export const Distances: {
	[key: string]: { label: string; match_code: number };
} = {
	FUENFZIG_M: {
		label: "50 m",
		match_code: 1
	},
	FUENFZIG_BIS_HUNDERT_M: {
		label: "50-100 m",
		match_code: 2
	},
	HUNDERT_BIS_FUENFHUNDERT_M: {
		label: "100-500 m",
		match_code: 3
	},
	FUENFHUNDERT_BIS_EIN_KM: {
		label: "500-1000 m",
		match_code: 4
	},
	EIN_BIS_FUENF_KM: {
		label: "1-5 km",
		match_code: 5
	},
	FUENF_BIS_ZEHN_KM: {
		label: "5-10 km",
		match_code: 6
	},
	ZEHN_BIS_ZWANZIG: {
		label: "10-20 km",
		match_code: 7
	}
};

export const NumberOfRooms: {
	[key: string]: { label: string; value: string };
} = {
	EIN_ZIMMER: {
		label: "filter.bedroomsCount.minOne",
		value: "1"
	},
	ZWEI_ZIMMER: {
		label: "filter.bedroomsCount.minTwo",
		value: "2"
	},
	DREI_ZIMMER: {
		label: "filter.bedroomsCount.minThree",
		value: "3"
	},
	VIER_ZIMMER: {
		label: "filter.bedroomsCount.minFour",
		value: "4"
	},
	FUENF_ZIMMER: {
		label: "filter.bedroomsCount.minFive",
		value: "5"
	}
};
